<script>
export default {
  props: {
    link: Object,
  },
  computed: {
    classes() {
      return ['text-brand-secondary-400', 'leading-loose', 'hover_underline'];
    },
  },
};
</script>

<template lang='pug'>
a.select-none.footer-link(v-if='link.external', :href='link.uri', :class='classes', target='_blank') {{link.text}}
router-link.select-none.footer-link(v-else, :to='{ name: link.uri, hash: link.hash }', :class='classes') {{link.text}}
</template>

<style>
@import '~import/index';

.footer-link.router-link-exact-active {
  text-decoration: underline;
}
</style>